import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_cookieuniversalnuxt_340d7025 from 'nuxt_plugin_cookieuniversalnuxt_340d7025' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_recaptcha_51c11b28 from 'nuxt_plugin_recaptcha_51c11b28' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_dayjsplugin_100e17c0 from 'nuxt_plugin_dayjsplugin_100e17c0' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_vlazyload_bbd414aa from 'nuxt_plugin_vlazyload_bbd414aa' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_router_6e391e5c from 'nuxt_plugin_router_6e391e5c' // Source: ./router.js (mode: 'all')
import nuxt_plugin_gtm_be4ca6da from 'nuxt_plugin_gtm_be4ca6da' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_fontawesome_46dfabff from 'nuxt_plugin_fontawesome_46dfabff' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vuetify_d6afc2c2 from 'nuxt_plugin_vuetify_d6afc2c2' // Source: ../plugins/vuetify.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_vueclipboards_7780ba7d from 'nuxt_plugin_vueclipboards_7780ba7d' // Source: ../plugins/vue-clipboards.js (mode: 'all')
import nuxt_plugin_dayjs_66ce5f68 from 'nuxt_plugin_dayjs_66ce5f68' // Source: ../plugins/dayjs.js (mode: 'all')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'all')
import nuxt_plugin_vuexroutersync_9c8d1186 from 'nuxt_plugin_vuexroutersync_9c8d1186' // Source: ../plugins/vuex-router-sync.js (mode: 'all')
import nuxt_plugin_polyfill_445bbb12 from 'nuxt_plugin_polyfill_445bbb12' // Source: ../plugins/polyfill.js (mode: 'client')
import nuxt_plugin_marketingevents_7f692021 from 'nuxt_plugin_marketingevents_7f692021' // Source: ../plugins/marketing-events.js (mode: 'client')
import nuxt_plugin_anonymoususer_ef195f94 from 'nuxt_plugin_anonymoususer_ef195f94' // Source: ../plugins/anonymous-user.js (mode: 'client')
import nuxt_plugin_useracquisition_0a4f8c6a from 'nuxt_plugin_useracquisition_0a4f8c6a' // Source: ../plugins/useracquisition.js (mode: 'client')
import nuxt_plugin_vueqrcode_09435728 from 'nuxt_plugin_vueqrcode_09435728' // Source: ../plugins/vue-qrcode.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s - Buser","title":"Viagens de ônibus com mais conforto pelo menor preço","htmlAttrs":{"lang":"pt-br"},"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=2"},{"hid":"og:type","name":"og:type","content":"website"},{"hid":"og:locale","property":"og:locale","content":"pt_BR"},{"hid":"og:title","property":"og:title","content":"Buser, o aplicativo do ônibus. Uma nova forma de viajar e economizar até 60%!"},{"hid":"og:site_name","property":"og:site_name","content":"Buser, o aplicativo do ônibus. Uma nova forma de viajar e economizar até 60%!"},{"hid":"og:description","property":"og:description","content":"Viaje de ônibus mais barato e mais seguro."},{"hid":"og:image","property":"og:image","content":"thumbnail.jpg"},{"hid":"og:image:type","property":"og:image:type","content":"image\u002Fpng"},{"hid":"og:image:width","property":"og:image:width","content":"540"},{"hid":"og:image:height","property":"og:image:height","content":"540"},{"hid":"fb:app_id","property":"fb:app_id","content":"124739094885613"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:image:alt","name":"twitter:image:alt","content":"Buser, o aplicativo do ônibus. Uma nova forma de viajar e economizar até 60%!"},{"hid":"twitter:site","name":"twitter:site","content":"@buserapp"},{"hid":"content-language","http-equiv":"content-language","content":"pt-br"},{"hid":"Language","name":"Language","content":"Portuguese"},{"hid":"google-site-verification","name":"google-site-verification","content":"aRvArDbGhfoAXRq31nPz-5-ZxyafQNcuztNB8FaJjbA"},{"hid":"robots","name":"robots","content":"index, follow"},{"hid":"googlebot","name":"googlebot","content":"index, follow"},{"hid":"DC.Creator","name":"DC.Creator","content":"Buser Brasil"},{"hid":"copyright","name":"copyright","content":"Buser Brasil"},{"hid":"Designer","name":"Designer","content":"Buser Brasil"},{"hid":"Publisher","name":"Publisher","content":"Viagens de ônibus com conforto e economia, Buser Brasil"},{"hid":"abstract","name":"abstract","content":"Loja Virtual"},{"hid":"subject","name":"subject","content":"Retail"},{"hid":"distribution","name":"distribution","content":"Global"},{"hid":"city","name":"city","content":"São Paulo"},{"hid":"country","name":"country","content":"Brazil"},{"hid":"rating","name":"rating","content":"General"},{"hid":"classification","name":"classification","content":"Online Store"},{"hid":"apple-itunes-app","name":"apple-itunes-app","content":"app-id=1383778218 \u002F\u002F"},{"hid":"google-play-app","name":"google-play-app","content":"app-id=br.com.buser.AppBuser"},{"hid":"HandheldFriendly","name":"HandheldFriendly","content":"true"},{"hid":"MobileOptimized","name":"MobileOptimized","content":"480"},{"hid":"format-detection","name":"format-detection","content":"telephone=no"},{"hid":"theme-color","name":"theme-color","content":"#AD1457"},{"hid":"msapplication-TileColor","name":"msapplication-TileColor","content":"#da532c"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"apple-touch-icon.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"favicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"favicon-16x16.png"},{"rel":"manifest","href":"site.webmanifest"},{"rel":"mask-icon","href":"safari-pinned-tab.svg"},{"rel":"shortcut icon","type":"shortcut icon","href":"favicon.ico"}],"script":[{"src":"https:\u002F\u002F514008706.collect.igodigital.com\u002Fcollect.min.js","defer":true,"body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-TTFLWBS')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-TTFLWBS&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_cookieuniversalnuxt_340d7025 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_340d7025(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_51c11b28 === 'function') {
    await nuxt_plugin_recaptcha_51c11b28(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_100e17c0 === 'function') {
    await nuxt_plugin_dayjsplugin_100e17c0(app.context, inject)
  }

  if (typeof nuxt_plugin_vlazyload_bbd414aa === 'function') {
    await nuxt_plugin_vlazyload_bbd414aa(app.context, inject)
  }

  if (typeof nuxt_plugin_router_6e391e5c === 'function') {
    await nuxt_plugin_router_6e391e5c(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_be4ca6da === 'function') {
    await nuxt_plugin_gtm_be4ca6da(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_46dfabff === 'function') {
    await nuxt_plugin_fontawesome_46dfabff(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_d6afc2c2 === 'function') {
    await nuxt_plugin_vuetify_d6afc2c2(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_vueclipboards_7780ba7d === 'function') {
    await nuxt_plugin_vueclipboards_7780ba7d(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_66ce5f68 === 'function') {
    await nuxt_plugin_dayjs_66ce5f68(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexroutersync_9c8d1186 === 'function') {
    await nuxt_plugin_vuexroutersync_9c8d1186(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfill_445bbb12 === 'function') {
    await nuxt_plugin_polyfill_445bbb12(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_marketingevents_7f692021 === 'function') {
    await nuxt_plugin_marketingevents_7f692021(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_anonymoususer_ef195f94 === 'function') {
    await nuxt_plugin_anonymoususer_ef195f94(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_useracquisition_0a4f8c6a === 'function') {
    await nuxt_plugin_useracquisition_0a4f8c6a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueqrcode_09435728 === 'function') {
    await nuxt_plugin_vueqrcode_09435728(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.push(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
